import classNames from 'classnames'
import React from 'react'
import {useSelectedVariantContext} from '../context/SelectedVariantContext'
import {UncontrolledTooltip} from 'reactstrap'
import {actionChangeSelectedAttribute} from '../context/SelectedVariantContext/action'
import useGTM, {buildProductPayload, getGTMAttributes} from '../../../hooks/useGTM'

export default function ProductAttributes() {
    const {
        dispatch,
        state: {mappedAttributes, product, pickerVariants = []},
    } = useSelectedVariantContext()

    const handleChangeAttributes = (key, data) => {
        dispatch(actionChangeSelectedAttribute({key, data}))
    }

    const _renderAttributes = () => {
        let output = []
        Object.entries(mappedAttributes).forEach(([key, values]) => {
            switch (key) {
                case 'color':
                    output.push(
                        <div key={key} className="ColorAttribute">
                            <div className="Title">Color</div>
                            <div className="GroupStyleColor">
                                <ul className="d-flex flex-wrap">
                                    {values.map((value, index) => {
                                        return (
                                            <li
                                                key={index}
                                                onClick={() => handleChangeAttributes(key, value)}
                                                {...getGTMAttributes('select_mockup', {product: buildProductPayload(product, pickerVariants)})}
                                            >
                                                <div
                                                    id={`htx_${index}`}
                                                    className={classNames('ColorItem', {
                                                        active: value.is_selected || false,
                                                    })}
                                                    style={{
                                                        backgroundColor: value.color_code,
                                                        // ...(value.value_code.includes('heather') && {
                                                        //     backgroundImage:
                                                        //         "url('/assets/images/heather_texture.png')",
                                                        // }),
                                                    }}
                                                />
                                                <UncontrolledTooltip target={`htx_${index}`}>
                                                    {value.value_text}
                                                </UncontrolledTooltip>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    )
                    break
                case 'label':
                case 'size':
                    output.push(
                        <div key={key} className="OtherAttributes">
                            <div className="GroupStyleAttribute">
                                <div className="Title text-capitalize">{key}</div>
                                <ul className="d-flex flex-wrap">
                                    {values.map((value, index) => {
                                        return (
                                            <li
                                                key={index}
                                                className={classNames(`${value.is_selected || false ? 'active' : ''}`)}
                                                onClick={() => handleChangeAttributes(key, value)}
                                                {...getGTMAttributes('select_mockup', {product: buildProductPayload(product, pickerVariants)})}
                                            >
                                                {value.value_text}
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    )
                    break
                default:
                    break
            }
        })
        return output
    }

    return <div>{_renderAttributes()}</div>
}

